import { postApi } from "@/utils/fetch";
import { Inquiry, Valuation, ValuationPrice } from "@/utils/valuation";
import PropertyType from "@/constants/PropertyType";

export type ValuationResponse = Valuation;

export const fetchValuationResultAsync = (
  abort: AbortController,
  inquirySearchId: string,
  contractSearchId: string
) => {
  return postApi<ValuationResponse>("/api/valuation/search", {
    body: JSON.stringify({ inquirySearchId, contractSearchId }),
  });
};

type Connecting = {
  status: string;
  details: {
    type: string;
    direction: string;
    width: string;
    contactWidth: string;
  }[];
};

export type UnitCondition = {
  type: typeof PropertyType.MANSION;
  pref: string;
  city: string;
  town: string;
  prefId: number;
  cityId: number;
  townId: number;
  line: string;
  station: string;
  walk: number;
  bus: number;
  floorPlan: string;
  roomNumber: string;
  story: number;
  builtDate: string;
  unitSize: number;
  balconyDirection: string;
  buildingName: string;
  totalStory: number;
  structure: string | null;
};

export type HouseCondition = {
  type: typeof PropertyType.HOUSE;
  pref: string;
  city: string;
  town: string;
  prefId: number;
  cityId: number;
  townId: number;
  line: string;
  station: string;
  walk: number;
  bus: number;
  floorPlan: string;
  builtDate: string;
  undergroundStory: number;
  totalStory: number;
  structure: string;
  houseSize: number;
  connecting: Connecting | null;
};

export type LandCondition = {
  type: typeof PropertyType.LAND;
  pref: string;
  city: string;
  town: string;
  prefId: number;
  cityId: number;
  townId: number;
  line: string;
  station: string;
  walk: number;
  bus: number;
  landSize: number;
  connecting: Connecting | null;
};

export type ValuationRequest = {
  inquiry: {
    customerId: string | null;
    contractId: number;
    lastName: string;
    firstName: string;
    lastNameKana: string | null;
    firstNameKana: string | null;
    mailAddress: string;
    canContactMail: boolean;
    tel: string;
    contactTime: string;
    canContactTel: boolean;
    postCode: string | null;
    pref: string | null;
    city: string | null;
    town: string | null;
    street: string | null;
    building: string;
    saleReason: string | null;
    salePeriod: string | null;
    relation: string | null;
    shopPrefId: string | null;
    shopId: string | null;
    trafficSourceId: string | null;
    referralSourceCd: string | null;
  };
  condition: HouseCondition | LandCondition | UnitCondition;
};

export const valuationAsync = (abort: AbortController, params: ValuationRequest): Promise<Inquiry> => {
  const result = postApi<Inquiry>("/api/valuation", {
    body: JSON.stringify(params),
  });
  return result;
};

export type ValuationApplyRequest = {
  valuationId: number;
  inquiryId: number;
};

export const valuationApplyAsync = (abort: AbortController, params: ValuationApplyRequest): Promise<ValuationPrice> => {
  return postApi<ValuationPrice>("/api/valuation/apply", {
    body: JSON.stringify(params),
  });
};

export default {
  valuationAsync,
  fetchValuationResultAsync,
};
